module.exports = __webpack_public_path__ + "static/media/bg.aabd8048.png";